import {
    UserAppPreferencesModel,
} from '../../models/user-app-preferences.model';
import { OnePointOh } from './1.0';

// eslint-disable-next-line @typescript-eslint/naming-convention
export const OnePointOne: Partial<UserAppPreferencesModel['reportsPrefs']['defaultChartColors']['mediaTypeColors']> = {
    TV: '#ffa180',
    facebook: '#292929',
    twitter: '#58595b',
    reddit: '#c7c7c7',
    youtube: '#5e6473',
    instagram: '#444444',
};

/**
 * Move Reports to its own section
 */
export function fromOnePointOhToOnePointOne(oldDataModel: UserAppPreferencesModel): UserAppPreferencesModel {
    const oldModel = oldDataModel as unknown as OnePointOh;
    const newModel = new UserAppPreferencesModel();
    newModel.version = '1.1';
    newModel.reportsPrefs = oldModel.monitoringPrefs.reportsPrefs;
    newModel.targetingPrefs = oldModel.targetingPrefs;
    newModel.monitoringPrefs = oldModel.monitoringPrefs;
    return newModel;
}
